// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__zn94d","resendInfoText":"OnGoingPaymentBox_resendInfoText__3SvrC"};